/* Sanaya, page Signature Journal : socle commun des sections sanaya-sig-*.
   Chaque section enregistre son initialisation : SB.i['nom'] = function (root) {...}, root = [data-sb="nom"].
   SB.run() initialise chaque racine une seule fois (au chargement, apres un changement de Signature, dans l'editeur). */
(function () {
  var SB = window.SB = window.SB || { i: {} };
  if (SB.ready) return;
  SB.ready = true;

  SB.run = function () {
    Object.keys(SB.i).forEach(function (name) {
      [].forEach.call(document.querySelectorAll('[data-sb="' + name + '"]:not([data-sb-on])'), function (root) {
        root.setAttribute('data-sb-on', '');
        try { SB.i[name](root); } catch (e) { if (window.console) console.error('[sanaya-sig]', name, e); }
      });
    });
  };

  /* Prix : centimes dans la devise du marche -> "$113" ou "$113.50" */
  SB.money = function (cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var v = cents / 100, whole = Math.round(v) === v;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(v);
    } catch (e) { return '$' + (whole ? v : v.toFixed(2)); }
  };

  SB.root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Ajout au panier : items = [{ id: variantId, quantity: 1 }]. Ouvre le panier tiroir du theme (Eurus : Alpine,
     xCartHelper + xMiniCart), avec le meme rafraichissement que le bouton d'origine ; sinon page panier. */
  SB.add = function (items, btn) {
    if (btn) btn.classList.add('is-busy');
    var A = window.Alpine, st = function (n) { try { return A && A.store ? A.store(n) : null; } catch (e) { return null; } };
    var helper = st('xCartHelper'), mini = st('xMiniCart'), body = { items: items };
    try { if (helper && helper.getSectionsToRender) { body.sections = helper.getSectionsToRender().map(function (x) { return x.id; }); body.sections_url = window.location.pathname; } } catch (e) {}
    return fetch(SB.root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (d) {
        if (btn) btn.classList.remove('is-busy');
        if (!mini || !mini.openCart) { window.location.href = SB.root + 'cart'; return; }
        try { if (helper && d.sections && helper.reRenderSections) helper.reRenderSections(d.sections); else if (mini.reLoad) mini.reLoad(); } catch (e) { try { mini.reLoad && mini.reLoad(); } catch (e2) {} }
        try { var bub = document.getElementById('cart-icon-bubble'); if (helper && bub) helper.currentItemCount = parseInt(bub.innerHTML, 10) || helper.currentItemCount; } catch (e) {}
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        mini.openCart();
      })
      .catch(function (e) { if (btn) btn.classList.remove('is-busy'); alert((e && (e.description || e.message)) || 'Sorry, this item could not be added.'); });
  };

  /* Changement de Signature sur place : on charge la page de l'autre produit (meme modele) et on remplace
     chaque section sanaya-sig par la sienne. L'adresse suit, le retour arriere recharge la page. */
  SB.swap = function (url, pushUrl) {
    document.documentElement.classList.add('sb-swapping');
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw r; return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html'), done = 0;
      [].forEach.call(document.querySelectorAll('.shopify-section'), function (sec) {
        if (!sec.querySelector('[data-sb]')) return;
        var nu = doc.getElementById(sec.id);
        if (nu) { sec.innerHTML = nu.innerHTML; done++; }
      });
      if (!done) throw new Error('no section');
      if (doc.title) document.title = doc.title;
      history.pushState({ sb: 1 }, '', pushUrl || url);
      SB.run();
      document.documentElement.classList.remove('sb-swapping');
    }).catch(function () { window.location.href = pushUrl || url; });
  };
  window.addEventListener('popstate', function (e) { if (e.state && e.state.sb) window.location.reload(); });
  history.replaceState({ sb: 1 }, '', window.location.href);

  /* Liens vers une autre Signature : changement sur place (sauf si une section l'a deja pris en charge) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-sb-swap]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    e.preventDefault();
    var top = a.getAttribute('data-sb-swap') === 'top';
    SB.swap(a.href).then(function () { if (top) window.scrollTo({ top: 0, behavior: 'smooth' }); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', SB.run); else SB.run();
  document.addEventListener('shopify:section:load', SB.run);
})();
